/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function Terms() {

    return (
        <div>
            <Row><h2>Terms and Conditions</h2></Row>
            <br />
            <Row>
                <p>
                    <b>Personal Information</b><br />
                    Grace Super Market is the licensed owner of Grace Daily and values your privacy. This Privacy Policy outlines how your data is collected and used by Grace Daily on the Site. By visiting or using the services of the Site, you agree to the terms of this Privacy Policy. We encourage all visitors and customers to read it carefully.<br />

                    <br /><b>Services Overview</b><br />
                    During registration, Grace Daily may collect personally identifiable information such as your full name, alternate email, mobile number, postal code, demographic details (age, gender, occupation, education, address), and browsing behavior including pages visited, links clicked, and frequency of visits.<br />

                    <br /><b>Eligibility</b><br />
                    The Site’s services are available only in select areas of Chennai. Individuals deemed "incompetent to contract" under the Indian Contract Act, 1872, including undischarged insolvents, are not eligible to use the Site. Minors aged 13 to under 18 may only use the Site under parental or guardian supervision. Minors below 18 cannot purchase adult-restricted items.<br />

                    <br /><b>License & Site Access</b><br />
                    Grace Daily grants you a limited, non-exclusive sub-license to access the Site for personal use only. Downloading, copying, modifying, reselling, or any commercial use of the Site or its contents is prohibited without written consent. Automated data extraction methods like data mining or bots are forbidden. You may not frame or use the Site’s trademarks or proprietary content without permission. Unauthorized use ends your license immediately.<br />

                    <br /><b>Account & Registration Obligations</b><br />
                    Registration and login are mandatory to place orders. You must provide accurate, up-to-date account details. By registering, you agree to receive promotional emails and newsletters, which you can opt out of anytime via "My Account" or customer service.<br />

                    <br /><b>Pricing</b><br />
                    Product prices on the Site are below MRP and fixed at the time of order placement. Some commodities and fresh food prices may vary daily; however, no additional charges or refunds will apply at delivery if prices differ.<br />

                    <br /><b>Order Cancellation</b><br />
                    Customers can cancel orders before the delivery slot cutoff by contacting customer service and receive a refund for payments made. Grace Daily reserves the right to cancel suspicious or fraudulent orders and deny service to such users.<br />

                    <br /><b>Return & Refunds</b><br />
                    Grace Daily offers a "no questions asked" return and refund policy. Unsatisfied customers may return products at delivery, and a credit note will be issued for future purchases.<br />

                    <br /><b>Your Responsibilities</b><br />
                    • You agree to bear any extra delivery costs caused by incorrect information you provide.<br />
                    • Use the Site lawfully and provide truthful information. Grace Daily may verify details and deny service for false information.<br />
                    • You accept full responsibility for transactions and deliveries at the provided address.<br />
                    • Check product descriptions carefully before ordering and agree to the terms of sale.<br />
                    • You must not use the Site to distribute unlawful, abusive, or harmful content, gain unauthorized system access, interfere with others’ Site use, violate laws, disrupt networks, or infringe intellectual property.<br />

                    <br /><b>Colors</b><br />
                    We strive to display product colors accurately, but actual colors may vary depending on your monitor.<br />

                    <br /><b>Modification of Terms & Conditions</b><br />
                    Grace Daily may update these Terms & Conditions at any time without prior notice. Continued use of the Site implies acceptance of the changes. You should review the Terms regularly and discontinue use if you do not agree.<br />

                    <br /><b>Governing Law and Jurisdiction</b><br />
                    This agreement is governed by Indian law, with exclusive jurisdiction in Chennai courts. Disputes will be resolved by arbitration under the Arbitration and Conciliation Act, 1996, held in Chennai. The High Court of Chennai has jurisdiction over these matters.<br />

                    <br /><b>Reviews, Feedback, Submissions</b><br />
                    Any feedback or comments you submit become the exclusive property of Grace Daily, granting us worldwide rights to use, modify, and distribute them without compensation or obligation. You must ensure your submissions do not violate any rights or contain unlawful or harmful content. Grace Daily may monitor and remove comments at its discretion.<br />

                    <br /><b>Copyright & Trademark</b><br />
                    All intellectual property on this Site belongs to Grace Super Market or its licensors. No rights or licenses to use trademarks, logos, or content are granted except for personal, non-commercial use. Unauthorized reproduction, modification, or commercial use is prohibited. References to third parties are for convenience only and do not imply endorsement. Grace Daily is not responsible for third-party content.<br />

                    <br /><b>Objectionable Material</b><br />
                    You acknowledge that you may encounter content deemed offensive or objectionable, and you agree to use the Site at your own risk. Grace Daily is not liable for such content.<br />

                    <br /><b>Indemnity</b><br />
                    You agree to indemnify and hold harmless Grace Daily, AKGS Info Tech, and their affiliates from any claims, losses, or damages arising from your actions, including breach of terms, violation of laws, or infringement of rights. This obligation continues even after termination of this agreement.<br />

                    <br /><b>Termination</b><br />
                    This agreement remains effective until terminated by you or Grace Daily. Either party may terminate at any time, with Grace Daily reserving the right to deny access immediately without liability. Upon termination, you must delete all downloaded materials. Termination does not relieve you of payment obligations for orders placed.<br />

                </p>
            </Row>
        </div>

    );
}

export default Terms;